import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row ,Spinner } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import schoolApi from "../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import { Oval } from 'react-loader-spinner'
import "../index.css"

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: "",
    school_code: "",
  });
  const [show, setShow] = React.useState(false);
  const [getotp, getOtp] = React.useState();
  const [otp, setOtp] = React.useState();
  const [timeRemaining, setTimeRemaining] = useState(60);
  const [flage, setFlage] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState();
  let [loader , setLoader ] = useState(false);

  const emailUsername = credentials.email.split("@")[0];
  const maskedUsername =
    emailUsername.length > 2
      ? `${emailUsername[0]}${"*".repeat(
          emailUsername.length - 2
        )}${emailUsername.slice(-1)}`
      : emailUsername;
  const setTimeOut = async (e) => {
    const timerInterval = setInterval(() => {
      setTimeRemaining((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timerInterval);
          setOtp();
          // Stop timer at 0
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timerInterval);
  };

  const handleSubmit = async (e) => {
    try{
      e.preventDefault();
      if (!credentials.email) {
        toast.error("Please enter email!");
        return;
      }
      if (!credentials.school_code) {
        toast.error("Please enter school code!");
        return;
      }
      let result;
      let otpResult;
      if (!flage || timeRemaining === 0) {
        setLoader(true)
        result = await schoolApi.ForgetPasswordApi(credentials);
        if (result.success) {
          setTimeRemaining(60);
          setTimeOut();
          toast.success(result.message);
          setLoader(false)
          setFlage(true);
        } else {
          setLoader(false)
          toast.error(result.message);
        }
      } else {
        if (!otp) {
          toast.error("Enter OTP First");
          return;
        }
          try{
            let schoolCode = credentials.school_code ? credentials.school_code : "public"
            console.log("schoolCode == ",schoolCode)
            otpResult = await schoolApi.CheckOtp(credentials.email,credentials.school_code,otp);
            if (otpResult.success) {
            setLoader(false)
              navigate(`/reset-password/${credentials.email}`, {
                state: { school_code: credentials.school_code },
              });
            } else {
              setLoader(false)
              toast.error("Incorrect OTP");
            }
          }catch(e){
            toast.error(e.response.data.message);
            setLoader(false)
          }
      }
    }catch(e){
      setLoader(false)

      toast.error(e.response.data.message);
    }
  };
  
  const handleChange = (e) => {
    console.log("value == ", e.target.value);
    if (e.target.name === "otp") {
      console.log("otp == ", e.target.value);
      const otpValue = e.target.value.replace(/\D/g, "").slice(0, 6);
      setOtp(otpValue);
      // setOtp(...otp,e.target.value)
    } else {
      setCredentials({ ...credentials, [e.target.name]: e.target.value });
    }
  };

  //created by shahir hussain 29-10-2024

  return (
    <Container className={loader ? 'disabled-screen' : ""}> 
        {
          // 
        /* { !loader ? */}
        {loader &&
          <div className="d-flex justify-content-center align-items-center loader_forget_passwords">
            <Oval
              visible={true}
              height="100"
              width="140"
              color="#275b6b"
              ariaLabel="oval-loading"
              wrapperClass=""
            />
          </div>
         }
        <Row>
        <div className="login-form-section pt-5" style={!flage ? { marginTop: "90px" } : {}}>
          <div className="forget-form-content">
            <div className="p-4">
              <Form className="mt-2" onSubmit={handleSubmit}>
                <div className="">
                  <h3 className="text-center ">
                    {" "}
                    <img src="comonLogoSchool.png" className="mb-2" height="100px" />
                  </h3>
                  {flage && (
                    <div>
                      <p className="fs-5 mt-4 text-bg-danger">
                        Enter your verification code
                      </p>

                      <p className="fs-5 mt-4">
                        Please enter one-time password to verify your account.
                      </p>
                      <p className="fs-5 ">
                        A code has been sent to {`${maskedUsername}@gmail.com`}
                      </p>
                    </div>
                  )}
                </div>

                <Alert variant="danger" show={show}>
                  {errorMessage}
                </Alert>
                <Form.Group className="mb-3 mt-2" controlId="formBasicusername">
                  {!flage &&(
                    <Row className="mt-3">
                      <Col lg={12} className="mt-3">
                        <Form.Label>Enter Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          onChange={handleChange}
                          placeholder="Enter Your Official Email"
                          // required
                          value={credentials.email}
                        />
                      </Col>
                      <Col lg={12} className="mt-3">
                          <Form.Label>Enter School Code</Form.Label>
                          <Form.Control
                            type="test"
                            name="school_code"
                            onChange={handleChange}
                            placeholder="Enter your school code"
                            // required
                            value={credentials.school_code}
                          />
                        </Col>
                    </Row>
                  )}
                  {flage &&
                  (
                    <Row className="mt-3">
                      {/* <Col lg={4}></Col> */}
                      <Col lg={12}>
                        <Form.Label>OTP</Form.Label>
                        <Form.Control
                          type="phone"
                          name="otp"
                          onChange={handleChange}
                          placeholder="Enter OTP"
                          // required
                          value={!(flage && timeRemaining === 0) ? otp : ""}
                        />
                        <div className="mt-2">
                          {timeRemaining !== 0 && (
                            <p>Time remaining: {timeRemaining} seconds</p>
                          )}
                          {timeRemaining === 0 && (
                            <p>
                              OTP expired. Please request a new one.
                              <span
                                className="mx-2"
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  fontWeight: "bold",
                                }}
                                onClick={handleSubmit}
                              >
                                Resend
                              </span>
                            </p>
                          )}
                        </div>
                      </Col>
                      {/* <Col lg={4}></Col> */}
                    </Row>
                  )
                  }

                  <Row className="mt-3">
                    <Col lg={12}>
                      <Button
                        className="btn btn-lg w-100 submit"
                        variant="primary"
                        type="submit"
                        disabled={flage && timeRemaining === 0}
                      >
                        {flage ? "Verify" : "Submit"}
                      </Button>
                    </Col>
                  </Row>
                </Form.Group>

                <center className="mt-3">
                  <strong>
                    <Link to="/login" style={{ textDecoration: "none" }}>
                      Back to Login
                    </Link>
                  </strong>
                </center>
              </Form>

              <center className="indicrm">
              </center>
            </div>
          </div>
        </div>
        </Row>
       
      <ToastContainer />
    </Container>
  );
};

export default ForgetPassword;